




























































































import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import PrepareForVerificationSvg from "@/modules/welcome/components/PrepareForVerificationSvg.vue";
import PrepareForVerificationDesktopSvg from "@/modules/welcome/components/PrepareForVerificationDesktopSvg.vue";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import axios from "axios";

@Component({
  metaInfo() {
    return {
      title: "Orba One | Terms of Service",
    };
  },
  components: {
    "previous-page-arrow": PreviousPageArrow,
    "prepare-for-verification": PrepareForVerificationSvg,
    "prepare-for-verification-desktop": PrepareForVerificationDesktopSvg,
  },
})
export default class TermsOfService extends Vue {
  @Action("nextPage") nextPage;
  isAgreed = false;

  async mounted() {
    if (Vue.prototype.$useAudioInstructions) {
      await Vue.prototype.$audioConfigs.playPrepareForVerification();
    }
  }

  beforeUnmount() {
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopPrepareForVerification();
    }
  }

  gotoPrepareForSelfie(event) {
    this.clickTos();
    this.$router.push({ name: "prepareSelfie", query: this.$route.query });
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopPrepareForVerification();
    }
  }

  clickTos() {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");
    const progressionStep = 2;

    if ((publicKey && applicantId) || magicLink) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
        {
          publicKey,
          progressionStep,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }
}
